import React, { SyntheticEvent } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import useTranslation from "../../../shared/hooks/useTranslation";
import colors from "../../../shared/themes/colors";
import { dt } from "../../../shared/themes/redesignTokens";

function a11yProps(index: number) {
  return {
    id: `login-tab-${index}`,
    'aria-controls': `login-tabpanel-${index}`,
  };
}

interface LoginSwitcherProps {
  onChange: (newValue: number) => void;
  value: number | string;
  showPinTab?: boolean;
}

const LoginSwitcher = ({ onChange, value, showPinTab = true }: LoginSwitcherProps) => {
  const { translate } = useTranslation("account");
  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    onChange(newValue);
  };

  return (
    <>
      {showPinTab && (
        <Box sx={{ width: "100%" }}>
          <Tabs
            sx={{
              width: "100%",
              "& .MuiTab-root": {
                fontSize: "18px !important",
                textTransform: "none",
                lineHeight: "28px",
                fontWeight: 400 + "!important",
                color: colors.secondary.gray20,
                borderRadius: "4px 4px 0 0",
                "&.Mui-selected": {
                  backgroundColor: colors.primary.lightBlue3 + "!important",
                  fontWeight: 600 + "!important",
                  color: dt.blue + "!important",
                  borderBottom: `1px solid ${dt.blue}`,
                },
                "&:hover": {
                  backgroundColor: colors.primary.lightBlue3 + "!important",
                  color: dt.blue + "!important",
                  borderBottom: `1px solid ${dt.blue}`,
                  fontWeight: 600 + "!important",
                }
              }
            }}
            onChange={handleChange}
            value={value}
            aria-label="log in variants"
            variant="fullWidth"
          >
            <Tab
              label={translate("emailSignIn")}
              value={0}
              {...a11yProps(0)}
            />
            <Tab
              label={translate("pinSignIn")}
              value={1}
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      )}
    </>
  )
};

export default LoginSwitcher;